import { useSnapshot } from 'valtio'
import { uiState } from '../data'
import { AnimatePresence, motion } from 'framer-motion'
import { isMobile } from 'react-device-detect'
import { useEffect, useRef, useState } from 'react'
import { windowSizeState } from '../utils/windowSize'

const Homepage = ({ event }) => {
  const gifRef = useRef()
  const scrollRef = useRef()
  const { visible, lang, data } = useSnapshot(uiState[event])
  const [isEnter1Hover, setIsEnter1Hover] = useState(false)
  const [isEnter2Hover, setIsEnter2Hover] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [showGif, setShowGif] = useState(true)
  const [showPeople, setShowPeople] = useState(false)
  const [showPng, setShowPng] = useState(false)
  const [showEnterBtn, setEnterBtn] = useState(false)
  const { mobileMode, phoneMode } = useSnapshot(windowSizeState)
  const [isPortrait, setIsPortrait] = useState(
    window.innerHeight > window.innerWidth && window.innerWidth <= 920
  )
  useEffect(() => {
    console.log(isPortrait)
  }, [isPortrait])

  const handleOrientationChange = () => {
    // 检查当前方向并更新状态
    setIsPortrait(window.innerHeight > window.innerWidth)
  }

  useEffect(() => {
    // 添加事件监听器
    window.addEventListener('resize', handleOrientationChange)

    // 在组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleOrientationChange)
    }
  }, [])

  const goVr = () => {
    let currentUrl = window.location.href
    var newUrl = currentUrl.replace('/start/start.html', '/vr/v0.html')
    window.location.href = newUrl
  }

  const goInfo = () => {
    setShowInfo(true)
  }

  const gifHandler = () => {
    setTimeout(() => {
      setShowPeople(true)
    }, 100)
    setTimeout(() => {
      setShowPng(true)
    }, 200)
    setTimeout(() => {
      setShowGif(false)
      setEnterBtn(true)
      setTimeout(() => {
        if (gifRef.current) {
          gifRef.current.src = `../startImages/IndexBg.gif?timestamp=${Date.now()}`
        }
      }, 200)
    }, 2400)
  }

  useEffect(() => {
    if (scrollRef.current && showInfo) {
      scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [lang])

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            className=' absolute top-0 left-0 screen-setting z-20 overflow-hidden'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* 把人拉到上層 */}
            <motion.div
              className='screen-setting absolute top-0 left-0 z-10 pointer-events-none '
              key={isPortrait}
              animate={{
                y:
                  showInfo && !mobileMode
                    ? '0%'
                    : showInfo && mobileMode && !phoneMode
                    ? '20%'
                    : showInfo && mobileMode && phoneMode
                    ? '25%'
                    : '0'
              }}
              transition={{ duration: 1, ease: 'linear' }}
            >
              <div className=' h-[80%] w-[65%]  absolute top-[50%] left-[48%] -translate-x-1/2 -translate-y-1/2 portraitPad:left-1/2 portraitPad:w-[90%] flex'>
                <div className='w-[25%] h-full portraitPad:flex portraitPad:items-end relative landscapePad:w-[35%] portraitPad:w-[35%] portraitBigPh:w-[45%]'>
                  <motion.img
                    src='../startImages/people.png'
                    alt='人'
                    className={`absolute  left-0  object-contain  h-full portraitPad:w-full portraitPad:h-auto translate-y-[10%]   ${
                      mobileMode ? 'bottom-[0px]' : 'bottom-0'
                    }`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: showPeople ? 1 : 0 }}
                  />
                </div>
                <div className='w-[75%] h-full portraitPad:flex portraitPad:justify-end flex flex-col landscapePad:w-[70%] portraitPad:w-[65%] portraitBigPh:w-[55%]'></div>
              </div>
            </motion.div>

            {/* 第二頁資訊頁 */}
            <motion.div
              className='screen-setting absolute top-0 left-0 z-10 pointer-events-none '
              initial={{ y: '100%', opacity: 0 }}
              animate={{ y: showInfo ? '0' : '100%', opacity: 1 }}
              transition={{ duration: 1, ease: 'linear' }}
            >
              <div className='w-[440px] h-[70%] absolute top-1/2 left-1/2 -translate-x-1/2  -translate-y-1/2 z-[999] NotoSansR pointer-events-auto landscapePad:w-[350px] portraitPad:w-[80%] portraitPad:top-[53%] portraitBigPh:top-1/2 portraitBigPh:w-[90%] landscapePhone:w-[50%] '>
                <div className='w-full h-[calc(100%-100px)]  flex flex-col landscapePad:h-[calc(100%-70px)] portraitPad:h-[calc(100%-280px)]  portraitBigPh:h-[calc(100%-130px)] landscapePhone:h-[calc(100%-50px)]'>
                  <div className='flex w-full justify-end tracking-[1.5px] mb-4 px-4 portraitPad:px-3 '>
                    <div
                      className={` rounded-[50%] w-[30px] h-[30px]  flex items-center justify-center mr-4 cursor-pointer  ${
                        lang === 'zh'
                          ? 'text-white bg-mainBlue-100'
                          : 'text-mainBlue-100'
                      }`}
                      onClick={() => {
                        uiState[event].lang = 'zh'
                      }}
                    >
                      中
                    </div>
                    <div
                      className={` rounded-[50%] w-[30px] h-[30px]  flex items-center justify-center mr-4 cursor-pointer  ${
                        lang === 'en'
                          ? 'text-white bg-mainBlue-100'
                          : 'text-mainBlue-100'
                      }`}
                      onClick={() => {
                        uiState[event].lang = 'en'
                      }}
                    >
                      EN
                    </div>
                    <div
                      className={` rounded-[50%] w-[30px] h-[30px]  flex items-center justify-center cursor-pointer ${
                        lang === 'cs'
                          ? 'text-white bg-mainBlue-100'
                          : 'text-mainBlue-100'
                      }`}
                      onClick={() => {
                        uiState[event].lang = 'cs'
                      }}
                    >
                      CS
                    </div>
                  </div>

                  <div
                    className={`leading-[32px] whitespace-pre-wrap overflow-y-scroll text-[18px] infoScroll px-4 landscapePad:text-[16px] portraitPad:text-[16px] portraitPad:px-3 landscapePhone:text-[16px] landscapePad:leading-[28px] portraitPad:leading-[28px] landscapePhone:leading-[28px] ${
                      lang === 'zh'
                        ? ' text-justify'
                        : ' text-left tracking-[1px]'
                    }`}
                    ref={scrollRef}
                  >
                    {lang === 'zh'
                      ? data.zhIntro
                      : lang === 'en'
                      ? data.enIntro
                      : data.csIntro}
                  </div>
                </div>
                <img
                  src={
                    !isMobile && isEnter2Hover
                      ? '../startImages/btn_introenter_hover.png'
                      : '../startImages/btn_introenter.png'
                  }
                  alt='第二頁enter按鈕'
                  className=' absolute bottom-0 right-0 translate-x-[50%] w-[120px] portraitBigPh:w-[100px] landscapePhone:w-[100px] cursor-pointer landscapePad:translate-x-[20%] portraitPad:translate-x-0 portraitPad:translate-y-[50%]'
                  onMouseEnter={() => {
                    setIsEnter2Hover(true)
                  }}
                  onMouseLeave={() => {
                    setIsEnter2Hover(false)
                  }}
                  onClick={goVr}
                />
              </div>
            </motion.div>

            {/* 第一頁 */}
            <motion.div
              className='screen-setting relative '
              animate={{ y: showInfo ? '-100%' : 0 }}
              transition={{ duration: 1, ease: 'linear' }}
            >
              {mobileMode && (
                <img
                  src='../startImages/cs_s1_title.png'
                  alt='上方文字'
                  className=' object-contain absolute top-[5%] left-[5%] w-[50%]  z-30 landscapePhone:w-[20%] landscapePhone:left-[30%]'
                />
              )}
              <img
                src='../startImages/IndexLogo.png'
                alt='主辦單位'
                className=' absolute left-1/2 -translate-x-1/2 bottom-[3%] w-[35%] z-20 landscapePad:w-[40%] portraitPad:w-[80%] portraitBigPh:w-[90%] object-contain landscapePhone:w-[50%]'
              />
              {showPng && (
                <motion.img
                  src={`../startImages/IndexBg.png`}
                  alt='第一張背景'
                  className='absolute top-0 left-0 w-full h-full object-cover'
                />
              )}
              <AnimatePresence>
                {showGif && (
                  <motion.img
                    src={`../startImages/IndexBg.gif?`}
                    alt='第一張背景'
                    className='absolute top-0 left-0 w-full h-full object-cover'
                    ref={gifRef}
                    onLoad={gifHandler}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  />
                )}
              </AnimatePresence>
              <div className=' h-[80%] w-[65%]  absolute top-[50%] left-[48%] -translate-x-1/2 -translate-y-1/2 portraitPad:left-1/2 portraitPad:w-[90%] flex'>
                <div className='w-[25%] h-full portraitPad:flex portraitPad:items-end landscapePad:w-[30%] portraitPad:w-[45%] '></div>
                <div className='w-[75%] h-full portraitPad:flex portraitPad:justify-end flex flex-col justify-between landscapePad:w-[70%] portraitPad:w-[70%] landscapePhone:justify-end landscapePhone:-translate-y-[7%]  '>
                  {!mobileMode && (
                    <img
                      src='../startImages/cs_s1_title.png'
                      alt='上方文字'
                      className=' object-contain w-[43%] h-[25%] landscapePad:w-[55%]'
                    />
                  )}

                  <div className='w-full h-[62%] flex flex-col justify-between items-end portraitPad:h-[65%]  portraitBigPh:h-[68%] portraitPad:justify-normal'>
                    <img
                      src='../startImages/zh_s1_title.png'
                      alt='中文標題'
                      className=' object-contain w-[60%] h-[60%]  landscapePad:w-[70%] portraitPad:w-full portraitPad:h-auto portraitPad:mb-[50px] portraitBigPh:mb-[25px]'
                    />

                    <motion.img
                      src={
                        !isMobile && isEnter1Hover
                          ? '../startImages/btn_enter_hover.png'
                          : '../startImages/btn_enter.png'
                      }
                      alt='第一頁next按鈕'
                      className={`w-[120px] object-contain cursor-pointer mb-[5%] portraitPad:mb-0 portraitBigPh:w-[100px] landscapePhone:w-[100px] landscapePhone:mt-[20px] ${
                        showEnterBtn
                          ? 'pointer-events-auto'
                          : 'pointer-events-none'
                      }`}
                      onMouseEnter={() => {
                        setIsEnter1Hover(true)
                      }}
                      onMouseLeave={() => {
                        setIsEnter1Hover(false)
                      }}
                      onClick={goInfo}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: showEnterBtn ? 1 : 0 }}
                      transition={{ duration: 0.5 }}
                    />
                  </div>
                </div>
              </div>
            </motion.div>

            {/* 第二頁 */}
            <motion.div
              className='screen-setting relative '
              animate={{ y: showInfo ? '-100%' : 0 }}
              transition={{ duration: 1, ease: 'linear' }}
            >
              <img
                src='../startImages/intro_bg.png'
                alt='第二張背景'
                className='absolute bottom-0 left-0 w-full h-full '
              />
              <img
                src='../startImages/zh_s2_title_2.png'
                alt='第二頁中文標題'
                className=' absolute top-[3%] left-[3%] z-30 w-[22%] landscapePad:w-[26%] portraitPad:w-[30%] portraitPad:left-[5%] portraitBigPh:w-[38%] landscapePhone:w-[20%]'
              />

              <div
                className={`absolute bottom-[31.5%]  z-30 w-[30%] landscapePad:bottom-[40%] landscapePad:w-[27%]  portraitPad:bottom-[12%] portraitPad:w-[22%] portraitBigPh:bottom-[8%] portraitBigPh:hidden landscapePhone:hidden  ${
                  isPortrait && mobileMode ? 'left-[37%]' : 'right-[6%]'
                }`}
                key={isPortrait}
              >
                <img
                  src='../startImages/en_s2_title_3.png'
                  alt=''
                  className={`w-[70%] portraitPad:w-full mb-[5%] portraitBigPh:mb-[20px] `}
                />
                <div className='w-full flex justify-end portraitPad:translate-x-[50%]'>
                  <img
                    src='../startImages/cs_s2_title_2.png'
                    alt=''
                    className={` w-[55%] portraitPad:w-full   `}
                  />
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Homepage
